// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  width: 100%;
}

.checkbox {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 5px;
  flex-wrap: wrap;
}

.auRoles {
  background-color: rgb(175, 201, 224);
}

.cdeRoles {
  background-color: rgb(241, 218, 143);
}

.selection {
  white-space: nowrap;
  width: 150px;
}

mat-icon {
  font-size: 20px;
  vertical-align: middle;
}

.mat-mdc-checkbox {
  width: 160px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/user-roles-selection/user-roles-selection.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":["mat-form-field {\r\n  width: 100%;\r\n}\r\n\r\n.checkbox {\r\n  list-style-type: none;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  padding-left: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.auRoles {\r\n  background-color: rgb(175, 201, 224);\r\n}\r\n\r\n.cdeRoles {\r\n  background-color: rgb(241, 218, 143);\r\n}\r\n\r\n.selection {\r\n  white-space: nowrap;\r\n  width: 150px;\r\n}\r\n\r\nmat-icon {\r\n  font-size: 20px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.mat-mdc-checkbox {\r\n  width: 160px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
